function plTrackAndTraceStart(orderNoParam) {
    const options = window.parcellab;

    if (!orderNoParam) {
        options.show_searchForm = true;
        options.show_zipCodeInput = true;
    } else {
        options.show_articleList = true;
        options.disableVoting = true;
        options.forceZip = false;
        options.rerouteButton = 'right';
    }

    window.parcelLabTrackAndTrace.initialize(options);
}


